var api = "https://api.qingcigame.com/web";
var index = "";
var go_page = window.location.href.split("?page=")[1];
var initialSlide = 0; //设置默认索引为0
var cur_num = "01"; // 当前页码

var obj = {
  index: function () {
    this.preloading(); // 预加载
    this.indexSwiper();
    this.indexBind(); // 首页按钮
    // this.countNum(); // 阿里云埋点
  },
  // 图片资源预加载
  preloading: function () {
    //图片预加载
    var queue = new createjs.LoadQueue();
    queue.on(
      "progress",
      function (e) {
        //加载中的进度
        if (e.progress * 100 >= 10) {
          $(".loding_time p").html(parseInt(e.progress * 100) + "%");
        }
        var numbers = e.progress * 100;
      },
      this
    );
    queue.on(
      "complete",
      function (e) {
        //加载完成执行操作
        var _this = this;
        $(".loding_time").remove();
        $(".preloading").addClass("preloading-ani").fadeOut(1000);
        $(".index").addClass("index-show");
        obj.indexSwiper();
        setTimeout(function () {
          $(".preloading").remove();
        }, 1000);
      },
      this
    );
    queue.loadManifest([
      //加载图片，不包括后台的
      "/official/images/pc/tip-f7f99e46f4.png",
      "/official/images/pc/gzh-fc4f007c2d.png",
      "/official/images/pc/app_download-19cc592051.png",
      "/official/images/pc/big-title-2a98b36c49.png",
      "/official/images/pc/bz-bb37ba8038.png",
      "/official/images/pc/dy-662192c77b.png",
      "/official/images/pc/gzh_-3880ac6936.png",
      "/official/images/pc/hykb-33d5d9a594.png",
      "/official/images/pc/ks-bf19a91c76.png",
      "/official/images/pc/ld_download-6c700e6402.png",
      "/official/images/pc/qr-code-b52b8bf0bb.png",
      "/official/images/pc/sub-title-291e887470.png",
      "/official/images/pc/tap_download-468a36bc7d.png",
      "/official/images/pc/wb-4c9f70bacb.png",
      "/official/images/pc/xhs-219b9bc4a0.png",
    ]);
  },
  // 首页按钮
  indexBind: function () {
    $('.download-btn').on("click", function () {
      let windowUrl = window.location.search;
      let Url = new URLSearchParams(windowUrl);
      var kol;
      for (const [key, value] of Url) {
        obj[key] = value;
        if (key == "kol") {
          kol = value;
        }
      }
      $.ajax({
        type: "get",
        url: "https://api.qingcigame.com/get_url?game_id=41",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        success: function (json) {
          if(json.code == 200) {
            if (kol) {
              // 安卓
              obj.countNum('pc-and-' + kol + '-download')
              setTimeout(() => {
                location.href = `https://download4.qcplay.com/apk-v2/${kol}.apk`;
              }, 200)
            } else {
              // 安卓
              obj.countNum('pc-and-official-download')
              setTimeout(() => {
                location.href = json.data.android_down_url;
              }, 200)
            }
          } else {
            layer.msg(json.message)
          }
        },
      });
    });
    $(".leidian-btn").on("click", function () {
      window.location.href = "https://lddl01.ldmnq.com/downloader/ldplayerinst9.exe?n=LDplayer9_com.zzonegame.aresvirus2.android_409372_ld.exe"
    });
    $(".hykb-btn").on("click",function () {
      window.location.href = "https://www.3839.com/a/128665.htm";
    })
    $(".gzh").hover(
      function () {
        // 鼠标移入
        $(".gzh-show").fadeIn();
      },
      function () {
        // 鼠标移出
        $(".gzh-show").fadeOut();
      }
    );
    $(".qw").hover(
      function () {
        // 鼠标移入
        $(".qw-show").fadeIn();
      },
      function () {
        // 鼠标移出
        $(".qw-show").fadeOut();
      }
    );
    $(".kefu-dialog").on("click", function () {
      $(".kefu-popup").fadeIn();
    });
    $(".age").on("click", function () {
      $(".age-popup").fadeIn();
    });
    // 声音开关
    var audio = document.getElementById("myMusic");
    $(".btn-music").on("click", function () {
      if (audio.paused) {
        audio.play();
        $(this).find("i").removeClass("shut");
      } else {
        audio.pause();
        $(this).find("i").addClass("shut");
      }
    });
    $(".close-bg").on("click", function () {
      $(".kefu-popup").fadeOut();
      $(".age-popup").fadeOut();
    });
    $(".monitor-btn").on("click", function () {
      var mon_btn = $(this).attr("data-event");
      console.log(mon_btn);
      obj.countNum(mon_btn);
    });
  },
  // 首页轮播
  indexSwiper: function () {
    if (window.location.href.includes("?"))
      initialSlide = this.getQueryVariable("index") || 0;

    function Ani(btn, page, swiperInstance) {
      $(btn).on("click", function () {
        swiperInstance.slideTo(page, 500, true);
      });
    }
    function navLink(swiperInstance) {
      for (let i = 3; i >= 0; i--) {
        Ani(`.nav-link-0${i} .link-a`, i, swiperInstance);
        Ani(".bottom-arrow", 1, swiperInstance);
      }
    }
    const aniLinks = [
      { selector: ".nav-box .top-btn", index: 0 },
      { selector: ".arrow-b", index: 1 },
      { selector: ".arrow-b2", index: 2 },
      { selector: ".arrow-b3", index: 3 },
    ];
    function setupAniLinks(swiperInstance) {
      aniLinks.forEach((link) =>
        Ani(link.selector, link.index, swiperInstance)
      );
    }
    function initSwiper(swiperContainer, swiperOptions) {
      return new Swiper(swiperContainer, swiperOptions);
    }
    const mySwiperOptions = {
      pagination: ".swiper-pagination",
      direction: "vertical",
      slidesPerView: "auto",
      paginationClickable: true,
      spaceBetween: 0,
      mousewheel: true,
      resistanceRatio: 0,
      initialSlide: initialSlide, // 假设 initialSlide 已经在某处定义
      touchMoveStopPropagation: false,
      touchStartForcePreventDefault: true,
      on: {
        init: function () {
          swiperAnimate(this); // 假设 swiperAnimate 已经在某处定义
          navLink(this);
          setupAniLinks(this);
        },
        slideChangeTransitionEnd: function () {
          $(".nav-link").removeClass("on");
          $(`.nav-link-0${this.activeIndex}`).addClass("on");
          $(".box-container").fadeIn();
        },
        reachEnd: function () {
          $(".box-container").fadeOut();
        },
        transitionEnd: function (swiper1) {
          if (mySwiper.snapIndex !== 3) $(".box-container").fadeIn();
        },
        transitionStart: function () {
          swiperAnimate(this);
        },
      },
    };
    const mySwiper = initSwiper(".swiper-container", mySwiperOptions);

    const newsSwiperOptions = {
      loop: true,
      paginationClickable: true,
      pagination: {
        el: ".swiper-pagination2",
        clickable: true,
      },
      slidesPerView: "auto",
    };

    setTimeout(() => {
      const newsSwiper = initSwiper(
        ".swiper-container-news",
        newsSwiperOptions
      );
    }, 500);

    const charitySwiperOptions = {
      loop: true,
      paginationClickable: true,
      pagination: {
        el: ".swiper-pagination4",
        clickable: true,
      },
      noSwiping: true,
      autoplayDisableOnInteraction: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      centeredSlides: true,
      slidesPerView: "auto",
      loopedSlides: 5,
      observer: true,
      observerParents: true,
      speed: 500,
      on: {
        init: function () {
          swiperAnimate(this);
        },
        slideChange: function () {
          if (this.realIndex == 0) {
            // 第一张
            $(".swiper-num .cur-num").text("01");
            $(".person1").fadeIn();
            $(".person5").fadeOut();
          } else if (this.realIndex == 1) {
            $(".person1").fadeOut();
            $(".person2").fadeIn();
            $(".swiper-num .cur-num").text("02");
          } else if (this.realIndex == 2) {
            $(".person2").fadeOut();
            $(".person3").fadeIn();
            $(".swiper-num .cur-num").text("03");
          } else if (this.realIndex == 3) {;
            $(".person3").fadeOut();
            $(".person4").fadeIn();;
            $(".swiper-num .cur-num").text("04");
          } else if (this.realIndex == 4) {
            $(".person4").fadeOut();
            $(".person5").fadeIn();
            $(".swiper-num .cur-num").text("05");
          }
        },
      },
    };

    const charitySwiper = initSwiper(
      ".swiper-container-feature",
      charitySwiperOptions
    );
  },
  // 获取当前hash的具体参数
  getQueryVariable: function (variable) {
    var query = window.location.href.split("?")[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  analysisParams: function (url) {
    const params = {};
    const paramsString = url.split("?")[1];
    if (!paramsString) {
      return params;
    }
    const str = paramsString.split("&");
    for (let idx = 0; idx < str.length; idx++) {
      const values = str[idx].split("=");
      params[values[0]] = values[1];
    }
    return params;
  },
  share: function () {
    var share_icon =
      "https://download4.qcplay.com/qcgame-api/4PwM3uU6Az1OaXmdoUWdHwHuSS57BU8ofEgJlnK3.png";
    var share_big_title = "《阿瑞斯病毒2》预约活动开启";
    var share_min_title =
      "末日生存手游《阿瑞斯病毒2》8月8日正式上线，速速预约拿限定外观";
    var share_link = window.location.href;
    outside.share(share_icon, share_big_title, share_min_title, share_link);
  },
  // 阿里云埋点
  countNum: function (data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
      } catch (e) {
        console.log(e);
      }
    }, 500);
  },
};
